<template>
  <div>
    <Head title="Product Families" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/settings/products/taxes">Impuestos</Link>
        <span class="text-indigo-400 font-medium">/ Editar</span>
      </h1>      
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">                    
          <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2" label="Descripción" />
          <text-input v-model="form.percentage" :error="form.errors.percentage" class="pb-8 pr-6 w-full lg:w-1/2" type="number" step="0.01" :label="'Porcentaje'" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-sky" type="submit">Actualizar Impuesto</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
  
<script>
import { Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
  
export default {
  components: {    
    Link,
    TextInput,    
    LoadingButton,    
    TrashedMessage,
  },
  layout: Layout,
  props: {
    taxes: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({        
        description: this.taxes.description,
        percentage: this.taxes.percentage        
      }),   
    }
  },
  methods: {
    update() {
      this.form.put(`/settings/products/taxes/${this.taxes.id}`)
    },
  },
}
</script>